import styles from "./styles";
import { getMyAccountUrl } from "../../helpers/getMyAccountUrl";
import { Button } from "@asosteam/asos-web-component-library-button";
import PropTypes from "prop-types";

const ExploreBenefits = ({ optedInButtonText }) => {
  return (
    <span className={styles.exploreBenefits}>
      <Button
        elementOverride="a"
        href={getMyAccountUrl("/my-account/asos-world")}
        buttonType="primary-asos-world"
        className={styles.exploreBenefitsLink}
        size="default"
      >
        {optedInButtonText}
      </Button>
    </span>
  );
};

export default ExploreBenefits;

ExploreBenefits.propTypes = {
  optedInButtonText: PropTypes.string,
};
